import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { RolleService } from '../../rolle.service';
import { loadRollenStart, loadRollenFailed, loadRollenSucceeded } from '../actions/rolle.actions';
import {changeRolleFailed, changeRolleStart, changeRolleSucceeded} from '../actions/change-rolle.actions';
import {loadUserStart} from '../../../landingpage/store/actions/getUser.actions';
import {loadUserRollenFailed, loadUserRollenStart, loadUserRollenSucceeded} from '../actions/getUserRollen.actions';
import {loadRechteFailed, loadRechteStart, loadRechteSucceeded} from '../actions/getAllRechte.actions';
import {addRolleFailed, addRolleStart, addRolleSucceeded} from '../actions/rolle-add.actions';
import {deleteRolleFailed, deleteRolleStart, deleteRolleSucceeded} from '../actions/rolle-del.actions';
import {editRolleFailed, editRolleStart, editRolleSucceeded} from '../actions/rolle-edit.actions';

@Injectable()
export class RolleEffects {
    /**
     * Loads the salutations when dispatching the start action
     */

    public loadRollen$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadRollenStart),
            mergeMap(() =>
                this.rolleService.getAllRollen().pipe(
                    map((response) => loadRollenSucceeded({ rollen: response.data })),
                    catchError(() => of(loadRollenFailed())),
                ),
            ),
        ),
    );

  public loadRechte$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadRechteStart),
      mergeMap(() =>
        this.rolleService.getAllRechte().pipe(
          map((response) => loadRechteSucceeded({ rechte: response.data })),
          catchError(() => of(loadRechteFailed())),
        ),
      ),
    ),
  );

  public loadUserRollen$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadUserRollenStart),
      mergeMap(() =>
        this.rolleService.getUserRollen().pipe(
          map((response) => loadUserRollenSucceeded({ rollen: response.data })),
          catchError(() => of(loadUserRollenFailed())),
        ),
      ),
    ),
  );

  public changeRolle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(changeRolleStart),
      mergeMap((value) =>
        this.rolleService.changeRolle(value.rolleId).pipe(
          mergeMap((rollenId, index) => of(
            changeRolleSucceeded({ rollenId }),
            loadUserStart({email: sessionStorage.getItem('email')}),
          )),
          catchError(() => of(changeRolleFailed())),
        ),
      ),
    ),
  );

  public addRolle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(addRolleStart),
      mergeMap((value) =>
        this.rolleService.addRolle(value.rolle).pipe(
          mergeMap((rolle, index) => of(
            addRolleSucceeded({rolle}),
            loadRollenStart(),
          )),
          catchError(() => of(addRolleFailed())),
        ),
      ),
    ),
  );

  public editRolle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(editRolleStart),
      mergeMap((value) =>
        this.rolleService.editRolle(value.rolle).pipe(
          mergeMap((rolle, index) => of(
            editRolleSucceeded({rolle}),
            loadRollenStart(),
          )),
          catchError(() => of(editRolleFailed())),
        ),
      ),
    ),
  );


  public deleteRolle$ = createEffect(() =>
    this.actions$.pipe(
      ofType(deleteRolleStart),
      mergeMap((value) =>
        this.rolleService.deleteRolle(value.item).pipe(
          mergeMap((rolle) => of(
            deleteRolleSucceeded({item: rolle}  ),
            loadRollenStart(),
          )),
          catchError((error) => of(deleteRolleFailed({error: 'Rolle konnte nicht gelöscht werden da sie schon einem Benutzer zugeteilt ist'}))),
        ),
      ),
    ),
  );

    /**
     * Constructor of address effects
     *
     * @param actions$ - The action observable
     * @param salutationsService - The salutations service
     */
    constructor(private actions$: Actions, private rolleService: RolleService) {}
}
